export default {
  tags: {
    handle: 'TagsConf',
    closeall: 'Close All',
    closeother: 'Close Other'
  },
  route: {
    dashboard: 'Dashboard',
    widget: 'Widget',
    permission: 'Permission',
    datatable: 'Datatable',
    components: 'Components',
    venue: 'Venue',                          //场馆管理
    venuecategory: 'Venuecategory',          //场馆类别管理
    page1: 'page1',
    page2: 'page2',
    page3: 'page3',
    profile: 'Profile',
    panels: 'Panels',
    user: 'User',                            // 用户管理
    role: 'Role',                            // 角色管理
    systemLog: 'SystemLog',                  // 系统日志
    website: 'Website',                      // 网络配置
    preference: 'Preference',                // 用户偏好设置
    booksRecommend: 'BooksRecommend',        // 新书推荐
    booksdonate: 'Booksdonate',              // 赠书芳名
    // booking: 'Booking',                      // 预约报名管理
    // bookingRecord: 'BookingRecord',          // 用户预约报名记录管理
    // ticketMGT: 'TicketMGT',                  // 票券管理
    // userTicketMGT: 'UserTicketMGT',          // 用户领票管理
    // contributeMGT: 'ContributeMGT',          // 投稿管理
    // userContributeMGT: 'UserContributeMGT',  // 用户投稿记录管理
    // luckDrawMGT: 'LuckDrawMGT',              // 抽奖管理
    // userLuckDrawMGT: 'UserLuckDrawMGT',      //用户抽奖记录管理
    // prizeSetting: 'PrizeSetting',            //奖品设置
    notice: 'Notice',                        //通知管理
    departmentDuty: 'DepartmentDuty',        //部门职位
    smsLog: 'SmsLog',                        //短信记录
    // visitorMGT: 'VisitorMGT',                //在线用户管理
    messageMGT: 'MessageMGT',                //消息推送管理
    // luckdraw: 'Luckdraw',                    //抽奖子系统
    // collarticket: 'Collarticket',            //抢票子系统
    // contribute: 'contribute',                //投稿子系统
    // bespeakenroll: 'Bespeakenroll',          //预约报名子系统
    // visitor: 'Visitor',                      //在线用户管理
    setting: 'Setting',                      //系统设置
    vrMGT: 'VRMGT',                          //VR管理
  //  recordMGT: 'RecordMGT',                  //用户投票记录管理
  //  templateMGT: 'templateMGT'               //子系统模板管理
  },
  app: {
    switchlang: 'Switch Language Success',
    unlock: 'UNLOCK'
  },
  login: {
    edenPart1: 'VUE',
    edenPart2: 'EDEN',
    title: 'Login Form',
    btn: 'Login',
    radioEN: 'English',
    radioZH: 'Chinese',
    forgetpwd: 'Forget Password',
    remember: 'Remember',
    userplaceholder: 'please enter lovely username',
    pwdplaceholder: 'please enter lovely password',
    valid: {
      userexist: 'please input username!',
      pwdexist: 'please input password!'
    },
    forget_email: 'please enter email',
    forget_code: 'please enter code',
    forget_passwrd: 'please enter new password',
    confirm_passwrd: 'confirm new password',
    forget_btn: 'Confirm',
    forget_back: 'Back',
    validfaild: 'Login form does not pass !',
    pwdChanged: 'Password Reset Successfully !'
  },
  sidebarDropDown: {
    profile: 'Profile',
    lock: 'Lock',
    logout: 'Logout',
    changePSW: 'Change Password'
  },
  msg: {
    msg1: 'You have a new message from Sakuya.',
    msg2: 'Chekcout today eden system report.',
    msg3: 'Eden system has some new update, check it.'
  },
  dashboard: {
    sr: 'System Report',
    pch: 'Pie Chart',
    todo: 'ToDo'
  },
  lock: {
    locked: 'Eden system has been locked!',
    unlock: 'Unlock Successfully!'
  }
}
